export default __webpack_public_path__ + "static/media/T_59_desktop.e410f7fb.jpg";